// extracted by mini-css-extract-plugin
module.exports = {"cta":"styles_cta__Ka1m_"};